module.exports = __webpack_public_path__ + "img/logoB.a1a46a9b.png";